export const calcBySeconds = (seconds) => {
	const minutes = Math.floor((seconds / 60) % 60);
	const hours = Math.floor(seconds / 60 / 60);

	return `${hours < 10 ? '0' + hours : hours}:${
		minutes < 10 ? '0' + minutes : minutes
	}:${seconds % 60 < 10 ? '0' + (seconds % 60) : seconds % 60}`;
};
